import { useState, useEffect } from "react";
import axios from "axios";
import { newEntityTypes, newEntityTypes3 } from "../jsonUtils/entityTypesJson";
import SearchForm from "../components/TimeLine/searchForm";
import LogsDisplay from "../components/TimeLine/showLogs";
import ErrorDisplay from "../components/TimeLine/errorDisplay";
import { useQuery } from "@tanstack/react-query";
import { Box } from "lucide-react";
import Alert from "@mui/material/Alert";
import useFetchWithMsal from "../hooks/useFetchWithMsal";
import { protectedResources } from "../authConfig";
import { isTestEnv } from "../globals";
 
const fetchTimelineLogs = async (formData, execute) => {
  const entity_num = formData.entityNumber;
  const entity_type = formData.entityType;
  const source = formData.sourceSystem;
  try {
    const response = await execute(
      "GET",
      `${process.env.REACT_APP_BACKEND_BASE_URL}/api/timeLine/getTimeLine/${entity_num}/${entity_type}/${source}`
    );
    console.log("responsess", response);
 
    return response;
  } catch (error) {
    isTestEnv && console.error("error", error);
  }
};
 
const TimeLine = () => {
  const [formData, setFormData] = useState({
    entityType: "",
    entityNumber: "",
    sourceSystem: "",
  });
  const { execute } = useFetchWithMsal({
    scopes: protectedResources.apiScopes.scopes.read,
  });
  const [noResults, setNoResults] = useState(false);
 
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["timelineLogs", formData, execute],
    queryFn: () => fetchTimelineLogs(formData, execute), // not {formData}
    enabled: false, // the function fetchTimelineLogs is execute only when refetch function called
    retry: false,
  });
 
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
 
  const handleSubmit = (e) => {
    e.preventDefault();
    refetch()
      .then((result) => {
        console.log("data", result.data.logs);
        if (result.data.logs.length === 0) {
          setNoResults(true);
        } else {
          setNoResults(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching logs:", error);
        setNoResults(false);
      });
  };
 
  return (
    <div className="min-h-screen bg-gray-50">
      <div
        className="container mx-auto px-4 py-8"
        style={{ marginTop: "4rem" }}
      >
        <SearchForm
          formData={formData}
          entityTypes={newEntityTypes3}
          loading={isLoading}
          handleInputChange={handleInputChange}
          setFormData={setFormData}
          fetchLogs={handleSubmit}
        />
 
        {isError && (
          <ErrorDisplay error={{ status: error?.response?.status || 500 }} />
        )}
 
        {data?.logs && <LogsDisplay logs={data.logs} />}
 
        {noResults && <ErrorDisplay error={{ status: 404 }} />}
      </div>
    </div>
  );
};
 
export default TimeLine;
